export * from './service-class.decorator';
